import { render, staticRenderFns } from "./ShopGridLs.vue?vue&type=template&id=4be4b240&scoped=true&"
import script from "./ShopGridLs.vue?vue&type=script&lang=js&"
export * from "./ShopGridLs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4b240",
  null
  
)

export default component.exports